import {
  ON_DUPLICATE_EVENT_CLICKED,
  ON_DUPLICATE_EVENT_CLOSED,
  UPDATE_DUPLICATE_EVENT_TITLE,
  UPDATE_DUPLICATE_EVENT_START_DATE,
  UPDATE_DUPLICATE_EVENT_END_DATE,
  UPDATE_DUPLICATE_EVENT_START_TIME,
  UPDATE_DUPLICATE_EVENT_END_TIME,
  TOGGLE_DUPLICATE_EVENT_ACCESS_KEYS,
  TOGGLE_DUPLICATE_EVENT_DISCOUNT_CODES,
  ON_DUPLICATE_EVENT_TITLE_ERROR,
  ON_DUPLICATE_EVENT_DATE_ERROR,
} from '../actions';

const initialState = {
  isOpen: false,
  eventId: '',
  eventTitle: '',
  eventTitleError: false,
  eventStartDate: '',
  eventStartTime: '',
  eventEndDate: '',
  eventEndTime: '',
  eventDateError: false,
  eventAccessKeys: false,
  eventDiscountCodes: false,
  predictedStart: '',
  predictedEnd: ''
};

export default (state = initialState, action) => {
  if (action.type === ON_DUPLICATE_EVENT_CLICKED) {
    return { ...state,
      isOpen: true,
      eventId: action.payload.id,
      eventTitle: action.payload.title,
      predictedStart: action.payload.start,
      predictedEnd: action.payload.end
    };
  }
  else if (action.type === ON_DUPLICATE_EVENT_CLOSED) {
    return initialState;
  }
  else if (action.type === UPDATE_DUPLICATE_EVENT_TITLE) {
    return { ...state, eventTitleError: false, eventTitle: action.payload };
  }
  else if (action.type === UPDATE_DUPLICATE_EVENT_START_DATE) {
    return { ...state, eventDateError: false, eventStartDate: action.payload };
  }
  else if (action.type === UPDATE_DUPLICATE_EVENT_START_TIME) {
    return { ...state, eventDateError: false, eventStartTime: action.payload };
  }
  else if (action.type === UPDATE_DUPLICATE_EVENT_END_DATE) {
    return { ...state, eventDateError: false, eventEndDate: action.payload };
  }
  else if (action.type === UPDATE_DUPLICATE_EVENT_END_TIME) {
    return { ...state, eventDateError: false, eventEndTime: action.payload };
  }
  else if (action.type === TOGGLE_DUPLICATE_EVENT_ACCESS_KEYS) {
    return { ...state, eventAccessKeys: !state.eventAccessKeys };
  }
  else if (action.type === TOGGLE_DUPLICATE_EVENT_DISCOUNT_CODES) {
    return { ...state, eventDiscountCodes: !state.eventDiscountCodes };
  }
  else if (action.type === ON_DUPLICATE_EVENT_TITLE_ERROR) {
    return { ...state, eventTitleError: true };
  }
  else if (action.type === ON_DUPLICATE_EVENT_DATE_ERROR) {
    return { ...state, eventDateError: true };
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/modules/my-events/reducers/duplicate-event-modal.js